import React from 'react';
import Tabela from '~/Components/TabelaDinamica/Tabela';
import { formatarDataAniversario } from '~/Services/GES/AniversariantesService';

// W-0607 — paridade cor de crédito UConAniver.pas:285-302.
// Backend devolve cor_credito textual: laranja(0)/verde(1)/vermelho(2)/preto(3).
const CORES_CREDITO = {
  laranja: '#f0820a',
  verde: '#1f9d4d',
  vermelho: '#d63232',
  preto: '#222222',
};

const BadgeCor = ({ corCredito }) => {
  const cor =
    corCredito && CORES_CREDITO[corCredito]
      ? CORES_CREDITO[corCredito]
      : CORES_CREDITO.verde;
  return (
    <span
      title={corCredito || 'verde'}
      style={{
        display: 'inline-block',
        width: '14px',
        height: '14px',
        borderRadius: '50%',
        backgroundColor: cor,
        border: '1px solid rgba(0,0,0,0.2)',
      }}
    />
  );
};

const COLUNAS = [
  {
    key: 'cor_credito',
    title: 'Crédito',
    align: 'center',
    width: '70px',
    render: value => <BadgeCor corCredito={value} />,
  },
  { key: 'nome_contato', title: 'Contato', ordenacao: true },
  {
    key: 'data_aniversario',
    title: 'Aniversário',
    align: 'center',
    ordenacao: true,
    render: value => formatarDataAniversario(value),
  },
  { key: 'celular', title: 'Celular' },
  { key: 'codigo_conta', title: 'Conta', align: 'right', ordenacao: true },
  { key: 'razao_social', title: 'Razão Social', ordenacao: true },
  { key: 'cidade', title: 'Cidade', ordenacao: true },
  { key: 'estado', title: 'UF', align: 'center', ordenacao: true },
  { key: 'ddd', title: 'DDD', align: 'center' },
  { key: 'fone', title: 'Fone' },
  { key: 'codigo_cargo', title: 'Cargo', align: 'right' },
  { key: 'codigo_vendedor', title: 'Vendedor', align: 'right' },
  { key: 'tipo_union', title: 'Tipo', align: 'center' },
];

const GridAniversariantes = ({ dados = [] }) => {
  return <Tabela colunas={COLUNAS} dados={dados} />;
};

export { CORES_CREDITO, BadgeCor };
export default GridAniversariantes;
